import React, { useCallback } from "react";
import { DeviceSelectionContainer } from "./DeviceSelectionContainer";
import { ConfigurationPageDeviceDropdown } from "./ConfigurationPageDeviceDropdown";
import { AudioDeviceInfo } from "@azure/communication-calling";


const grantedIconName = 'LocalDeviceSettingsSpeaker';


interface SpeakerSelectionProps {
    defaultPlaceHolder: string;
    noSpeakersLabel: string;
    speakers: AudioDeviceInfo[];
    selectedSpeaker?: AudioDeviceInfo;
    onSelectSpeaker: (speaker: AudioDeviceInfo) => void;
    defaultSpeaker?: AudioDeviceInfo;
}

export const SpeakerSelection = (props: SpeakerSelectionProps): JSX.Element => {

    const {
        onSelectSpeaker,
        speakers,
        selectedSpeaker,
        defaultPlaceHolder,
        noSpeakersLabel,
        defaultSpeaker,
    } = props;

    const onSelectSpeakerCb = useCallback((speakerId: string) => {
        const speaker = props.speakers.find(s => s.id === speakerId);
        onSelectSpeaker(speaker!);
    }, [onSelectSpeaker, props.speakers]);

    return (
        <DeviceSelectionContainer iconName={grantedIconName}>
            <ConfigurationPageDeviceDropdown
                ariaLabelledby={'call-composite-local-sound-settings-label'}
                defaultPlaceHolder={defaultPlaceHolder}
                devices={speakers}
                onSelectDevice={onSelectSpeakerCb}
                deviceAccessGranted={true}
                noDevicesLabel={noSpeakersLabel}
                defaultDevice={defaultSpeaker}
                selectedDevice={selectedSpeaker}
            />
        </DeviceSelectionContainer>
    );
};
